module.exports = __webpack_public_path__ + "step3_child_to_parent_daughter.50fbb6bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step3_child_to_parent_daughter.jpg
// module id = uBw7
// module chunks = 0